import { SharedModule } from '../shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TasksRoutingModule } from './tasks-routing.module';
import { MaterialModule } from '../material.module';
import { TasksComponent } from './tasks.component';
import { TasksListComponent } from './components/tasks-list/tasks-list.component';
import { TaskDetailsComponent } from './components/task-details/task-details.component';
import { TaskHeaderComponent } from './components/task-header/task-header.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TasksDateRangeFilterComponent } from './components/tasks-date-range-filter/tasks-date-range-filter.component';
import { TaskFileContentsComponent } from './components/task-file-contents/task-file-contents.component';
import { TaskAuditTrailComponent } from './components/task-audit-trail/task-audit-trail.component';

@NgModule({
  declarations: [
    TasksComponent,
    TasksListComponent,
    TaskDetailsComponent,
    TaskHeaderComponent,
    TasksDateRangeFilterComponent,
    TaskFileContentsComponent,
    TaskAuditTrailComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    TasksRoutingModule,
    MaterialModule,
    ReactiveFormsModule
  ]
})
export class TasksModule { }
